/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class l{constructor(l=null,t=null,s=null){this.composite=l,this.normal=t,this.highlight=s}}export{l as RenderPluginInput};
